// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './SpecificationsTable.module.scss';;


type Props = {
  children: React.Node,
  className?: string,
}

export const Table = ({ children, className }: Props) => (
  <table className={classNames(styles.table, className)}>
    <tbody>
      {children}
    </tbody>
  </table>
);

export const Row = ({ children, className }: Props) => (
  <tr className={classNames(styles.tr, className)}>
    {children}
  </tr>
);

export const Cell = ({ children, className }: Props) => (
  <td className={classNames(styles.td, className)}>
    {children}
  </td>
);
